import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { App } from './App';
import { SessionProvider } from '@adiox/ui';
import { startThemeSync } from '@adiox/ui';
import { startInstallSupport } from './shell/install';

startThemeSync();
startInstallSupport(import.meta.env.PROD);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
);
